import { render, staticRenderFns } from "./Dependency.vue?vue&type=template&id=34c76659&scoped=true&"
import script from "./Dependency.vue?vue&type=script&lang=js&"
export * from "./Dependency.vue?vue&type=script&lang=js&"
import style0 from "./Dependency.vue?vue&type=style&index=0&id=34c76659&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c76659",
  null
  
)

export default component.exports